import Marquee from "react-fast-marquee";

const WORDS = [
  "24/7 ROADSIDE ASSISTANCE",
  "TYRE · BATTERY · TOWING",
  "FUEL · SERVICING · INSURANCE",
  "ANY VEHICLE · ANY ROAD",
];

export const EditorialMarquee = () => {
  return (
    <div
      data-testid="editorial-marquee"
      className="border-y border-white/10 bg-rescue-bg py-6 marquee-fade"
    >
      <Marquee speed={40} gradient={false} autoFill>
        {WORDS.map((w, i) => (
          <span key={i} className="flex items-center">
            <span
              className="font-display uppercase text-5xl sm:text-7xl tracking-tight px-8 text-transparent"
              style={{ WebkitTextStroke: "1px rgba(255,255,255,0.28)" }}
            >
              {w}
            </span>
            <span className="text-rescue-primary text-4xl">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
};
